export const HELP_CONTEXT: Record<string, Record<string, string[]>> = {
	dentlab: {
		"/": ["dentlab/dashboard"],
		"/client/:clientId": ["dentlab/kunden"],
		"/client/:clientId/dateiarchiv": ["dentlab/archiv"],
		"/archive": ["dentlab/archiv"],
		"/client/:clientId/job/:jobId": [
			"dentlab/auftraege",
			"dentlab/dokumente",
		],
		"/organisation/pdf": ["dentlab/dokumente"],
		"/organisation/kataloge": ["dentlab/einstellungen"],
		"/organisation/auftragsansichten": ["dentlab/auftragsansichten"],
		"/debitoren": ["dentlab/buchhaltung"],
		"/debitoren/mahnwesen": ["dentlab/mahnwesen", "dentlab/buchhaltung"],
		"/monthly-invoices": ["dentlab/buchhaltung"],
		"/statistics": ["dentlab/dashboard"],
		"/chats": ["dentlab/chat"],
		"/agenda": ["dentlab/agenda"],
		"/vendor/:vendorId": ["dentlab/fremdlabore"],
		"/deliveries": ["dentlab/lieferungen"],
		"/organisation/administration/drucker": ["dentlab/drucksystem"],
		"/organisation/administration/druckerauftraege": ["dentlab/drucksystem"],
		"/organisation/administration/benutzerverwaltung": [
			"dentlab/benutzerverwaltung",
		],
		"/organisation/administration/mahnungswesen": [
			"dentlab/mahnwesen",
			"dentlab/einstellungen",
		],
		"/organisation/administration/konfigurationseinstellungen": [
			"dentlab/einstellungen",
		],
		"/auftragsformulare": ["dentlab/auftragsformulare"],
		"/auftragsformulare/:formId": ["dentlab/auftragsformulare"],
	},
	dentconnect: {
		"/": ["dentconnect/index"],
		"/vendor/:vendorId": ["dentconnect/labore"],
		"/chats": ["dentconnect/auftraege"],
		"/agenda": ["dentconnect/agenda"],
	},
};

export function getHelpSlugsForRoute(
	route: string,
	app: string
): string[] | null {
	const appContext = HELP_CONTEXT[app];
	if (!appContext) return null;

	for (const [pattern, slugs] of Object.entries(appContext)) {
		if (matchRoute(pattern, route)) return slugs;
	}
	return null;
}

function matchRoute(pattern: string, route: string): boolean {
	const patternParts = pattern.split("/");
	const routeParts = route.split("/");

	if (patternParts.length !== routeParts.length) return false;

	return patternParts.every(
		(part, i) => part.startsWith(":") || part === routeParts[i]
	);
}
